import { Checkbox, CheckboxProps } from '@elements/checkbox'
import { FormField, FormFieldProps } from './field'

export type CheckboxFieldProps = Omit<
  FormFieldProps<CheckboxProps>,
  'component' | 'label'
>

export function CheckboxField(props: CheckboxFieldProps) {
  return <FormField {...props} component={Checkbox} />
}
